import { API_KEY, API_URL_WITHOUT_USER } from "../../Utils/API";
import {
  getDispatch,
  getSnackbarSuccess,
  isLoadingAction,
} from "../../Utils/helper";
import { HttpUtil } from "../../Utils/http-utils";
import ROUTES from "../../Utils/routesConstants";
import { getToken, GET_STAFF_DETAILS, getTempararyTokenProviderAssist, getCampaignsToken } from "../../Utils/types";

export const getAllStaffDetails = () => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = window.location.pathname.includes("campaigns")
  ? `${API_URL_WITHOUT_USER}/Campaigns/GetAllStaffDetails/${getCampaignsToken()}`
  : `${API_URL_WITHOUT_USER}/StaffDetails/GetAllStaffDetails`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      ApiKey: API_KEY,
      Authorization: window.location.pathname.includes(ROUTES.PROVIDER_ASSIST)
      ? getTempararyTokenProviderAssist() : window.location.pathname.includes("campaigns") ? null
      : getToken(),
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_STAFF_DETAILS, res?.data?.results, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_STAFF_DETAILS, {}, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const addStaffDetails = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = window.location.pathname.includes("campaigns")
  ? `${API_URL_WITHOUT_USER}/Campaigns/AddUpdateStaffDetails/${getCampaignsToken()}`
  : `${API_URL_WITHOUT_USER}/StaffDetails/AddUpdateStaffDetails`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: window.location.pathname.includes(ROUTES.PROVIDER_ASSIST)
      ? getTempararyTokenProviderAssist() : window.location.pathname.includes("campaigns") ? null
      : getToken(),
  }).then((res) => {
    if (res?.data?.status === true) {
      isLoadingAction(false, dispatch);
      getSnackbarSuccess("success", "Details updated successfully", dispatch);
    } else {
      isLoadingAction(false, dispatch);
      getSnackbarSuccess("error", res?.data?.message, dispatch);
    }
  });
};
